<template>
  <transition name="fade">
    <v-container v-show="mostrar" class="panelFiltro">
      <!-- <v-btn icon dark @click.native="table.filtros.fechar = false">
        <v-icon color="red">close</v-icon>
      </v-btn> -->
      <v-layout row wrap>
        <v-flex
          class="inptFiltroRS"
          xs12
          sm6
          md4
          xl3
          v-for="(item,i) in table.filtros.items"
          :key="i"
          v-if="item.type == 'T'"
        >
          <v-text-field v-model="item.valor" prepend-icon="R$" @input="mask(item)" clearable>
            <template slot="label">
              <small>{{item.text}}:</small>
            </template>
          </v-text-field>
        </v-flex>
        <v-flex
          xs12
          sm6
          md4
          xl3
          v-for="(item,i) in table.filtros.items"
          :key="i"
          v-if="item.type == 'S' && component.name != 'CTE' && component.name != 'NFSE' || (component.name == 'CTE' || component.name == 'NFSE') && item.type == 'S' 
        && (item.item_id != 'manifestacao' && item.item_id != 'protocolada' && item.item_id != 'cce' && item.item_id != 'tipoVencimento') "
        >
          <v-select
            :items="item.options"
            label="Solo field"
            v-model="item.valor"
            clearable
            :multiple="item.multiple"
            persistent-hint
            :prepend-icon="item.icon"
            :change="getSelect(item.item_id == 'tipoVencimento' ? item : null)"
          >
            <template slot="label">
              <small>{{item.text}}:</small>
            </template>
          </v-select>
        </v-flex>

        <v-flex
          xs12
          sm6
          md4
          v-for="(item,i) in table.filtros.items"
          :key="i"
          v-if="item.type == 'D' && component.name != 'CTE' && component.name != 'NFSE' || item.type == 'D' && item.item_id != 'vencimentoIni' && item.item_id != 'vencimentoFim' && item.item_id != 'tipoVencimento'"
        >
          <v-menu
            :ref="item.index"
            :close-on-content-click="false"
            v-model="item.index"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :class="[item.item_id == 'vencimentoFim' || item.item_id == 'vencimentoIni'  ? 'fDtVencimento' : ''] "
          >
            <v-text-field
              :close-on-content-click="true"
              slot="activator"
              v-model="item.valor"
              persistent-hint
              prepend-icon="event"
              clearable
              @click:prepend-inner="openMenu($event)"
              @blur="validateDate($event,item)"
              :mask="maskData"
            >
              <template slot="label">
                <small>{{item.text}}</small>
              </template>
            </v-text-field>
            <v-date-picker
              @input="item.valor = formatDate($event), item.index = false"
              locale="pt-br"
              v-model="item.data"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex
          v-if="component.name === 'NFSE' && component.tipo !== 'emitida' && empresa.servicos && empresa.servicos.robotizacao && empresa.servicos.robotizacao.find(item => item.nomeServico === 'NFSE_TOMADOS') && item.type === 'L'"
          xs12
          sm6
          md4
          v-for="(item,i) in table.filtros.items"
          :key="i"
          :empresa="empresa"
          :component="component"
        >
          <v-select
            :label="item.label"
            clearable
            :multiple="item.multiple"
            persistent-hint
            :items="item.options"
            :prepend-icon="item.icon"
            v-model="item.valor"
          >
            <template slot="label">
              <small>{{item.text}}:</small>
            </template>
          </v-select>
      </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-btn outline flat color="teal" @click="fecharPanelFiltro()">
          <small style="color:#009688;">Fechar</small>
        </v-btn>
        <v-btn outline flat color="teal" @click="returnFiltro(false)">
          <small style="color:#009688;">Limpar Filtro</small>
        </v-btn>
        <v-btn color="teal" @click="returnFiltro(true)">
          <small style="color:white;">Filtrar</small>
        </v-btn>
      </v-layout>
    </v-container>
  </transition>
</template>


<script>
export default {
  props: ["mostrar", "table", "component", "empresa"],
  data: () => ({
    menu0: false,
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    real: "",
    maskData: "##-##-####"
  }),
  updated: function() {
    this.$nextTick(function() {
      // this.getSelect(this.table.filtros.items[12].valor);
    });
  },
  computed: {},
  watch: {},
  methods: {
    getSelect: function(v) {
      if (v != null) {
        var fields = document.querySelectorAll(".fDtVencimento");
        if (v.valor == "Não informado") {
          fields.forEach(e => {
            e.classList.add("v-menu__activator--disabled");
          });
          this.vencimentoIni = null;
          this.vencimentoFim = null;
        } else {
          fields.forEach(e => {
            e.classList.remove("v-menu__activator--disabled");
          });
        }
      }
    },
    mask(item) {
      if (item.valor != null) {
        let v = item.valor;
        v = this.addVirgula(v);
        v = v.replace(/(\d+)(\d{3},\d{2})$/g, "$1.$2"); //Coloca o primeiro ponto
        var qtdLoop = (v.length - 3) / 3;
        var count = 0;
        while (qtdLoop > count) {
          count++;
          v = v.replace(/(\d+)(\d{3}.*)/, "$1.$2"); //Coloca o resto dos pontos
        }
        v = v.replace(/^(0+)(\d)/g, "$2"); //remove "0" Ă  esquerda
        item.valor = v;
      }
    },
    addVirgula: function(v) {
      v = v.replace(/\D/g, ""); //Remode tudo o que não é dígito
      v = v.replace(/(\d+)(\d{2})/, "$1,$2");
      return v;
    },
    resetFiltro: function() {
      this.table.resetFiltro();
      this.emissaoIni = null;
      this.emissaoFim = null;
      this.importacaoIni = null;
      this.importacaoFim = null;
      this.vencimentoIni = null;
      this.vencimentoFim = null;
    },
    fecharPanelFiltro(){
      this.table.filtros.fechar = true;
      this.$emit("getFiltro", this.table.filtros);
    },
    returnFiltro: function(boolean) {
      this.table.filtros.fechar = boolean;
      if (!boolean) {
        this.resetFiltro();
      }
      this.table.filtros.items.forEach(item => {
        switch (item.type) {
          case "D":
            if (item.valor != null && item.valor.length == 8) {
              var aux = item.valor.substring(0, 2).concat("-");
              aux += item.valor.substring(2, 4).concat("-");
              aux += item.valor.substring(4, 8);
              item.valor = aux;
            } else {
              item.valor = null;
            }
            break;
        }
      });
      this.$emit("getFiltro", this.table.filtros);
    },
    openMenu(e) {},
    validateDate(field, item) {
      if (field.target.value.length == 10) {
        item.valor = field.target.value.split("-").join("");
        item.data = field.target.value
          .split("-")
          .reverse()
          .join("-");
      }
    },
    setHifenDate(v) {},
    formatDate(date, menu) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    }
  }
};
</script>
<style scoped>
.rangeDate .flex {
  padding: 0 !important;
}
.active {
  background-color: rgb(0, 150, 136) !important;
}
.panelFiltro {
  margin-top: 20px;
}
.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: all 1s;
}
.fade-leave {
  opacity: 1;
}
.fade-leave-active {
  transition: all 1s;
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/dataTable/commonTable/actionsHeader/btnFiltrar/panelFiltro/PanelFiltro.vue